module.exports = __webpack_public_path__ + "img/Weapon_113.a4c40f35.png";